import { useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const privateRoutes = ['/dashboard', '/transactions', '/planning', '/bills', '/cards', '/accounts', '/reports', '/assistant', '/alerts', '/settings'];

export default function ThemeToggle({ inline = false }) {
 const location = useLocation();
 const [theme,setTheme]=useState(()=>localStorage.getItem('lumine_theme') || 'dark');
 const change=()=>{const next=theme==='dark'?'light':'dark';setTheme(next);localStorage.setItem('lumine_theme',next);document.documentElement.dataset.theme=next;};
 const isPrivate = privateRoutes.some((route) => location.pathname.startsWith(route));
 if (isPrivate && !inline) return null;
 const label = theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro';
 return <button className={inline ? 'theme-toggle-inline' : 'theme-toggle'} onClick={change} aria-label={label} title={label}><Sun size={17} className={theme==='light'?'theme-active':''}/><Moon size={17} className={theme==='dark'?'theme-active':''}/>{inline && <span>{theme === 'dark' ? 'Tema escuro' : 'Tema claro'}</span>}</button>;
}

